import ScholarshipsImg from "../../assets/homepage/tiles/university-scholarships.jpg";
import BonusPointsImg from "../../assets/homepage/tiles/university-adjustment-factors.jpg";
import AltEntryImg from "../../assets/homepage/tiles/university-alternative-entry.jpg";
import ATSIImg from "../../assets/homepage/tiles/university-atsi-2.jpg";
import ExchangeImg from "../../assets/homepage/tiles/university-overseas-exchange.jpg";
import AccommodationImg from "../../assets/homepage/tiles/university-accommodation.jpg";
import VirtualTourImg from "../../assets/homepage/tiles/university-open-days.jpg";
import EarlyEntryImg from "../../assets/homepage/tiles/university-early-entry-srs.jpg";
import TileImageStore from "../../assets/JobJumpPageImages";
import UniLogos from "../../assets/UniLogos";
import {GenericImages} from "../../assets/GenericImages";

export type LinkTo = {
    link : string,
    text? : string
};

export type CategoryTypes = 
    "scholarships" | 
    "bonusPoints" | 
    "alternativeEntry" | 
    "earlyEntry" |
    "atsi" | 
    "exchange" | 
    "accommodation" | 
    "virtualTour" ;

const uniCategoryPrettyNames : {[k in CategoryTypes]:string} = {
    "scholarships": "Scholarships",
    "earlyEntry": "Early Entry",
    "bonusPoints": "Adjustment Factors" ,
    "alternativeEntry": "Alternative Entry", 
    "virtualTour": "Virtual Tour",
    "atsi": "First Nations", 
    "accommodation": "Accommodation",
    "exchange": "Overseas Exchange", 
}

const uniCategoryImages : {[k in CategoryTypes]:string[]} = {
    "scholarships": [ScholarshipsImg, TileImageStore["GettingYouTaxFileNumber"]],
    "bonusPoints": [BonusPointsImg, TileImageStore["StudentMoneyHelp"]],
    "alternativeEntry": [AltEntryImg], 
    "earlyEntry": [EarlyEntryImg, GenericImages.FeetOnPavement],
    "virtualTour": [VirtualTourImg],
    "atsi": [ATSIImg], 
    "accommodation": [AccommodationImg],
    "exchange": [ExchangeImg], 
}

type UniEvent = {
    date?: Date,
    url: string,
    campus?:string
};
 
export type UniConfig = {
    [k in CategoryTypes]: LinkTo[];
} & {id:string, image:string, states:string[], abbr:string, events:UniEvent[]};

const uniConfig : {[k:string] : UniConfig} = {
    "Australian Catholic University" : {
        id:"175",
        abbr: "ACU",
        states: ["NSW", "VIC", "ACT", "QLD"],
        image:UniLogos["ACU"],
        "scholarships" : [{
            link : "http://www.acu.edu.au/study_at_acu/courses/scholarships_and_financial_support",
            text : "Summary"
        }, 
        {
            link : "http://www.acu.edu.au/study_at_acu/courses/scholarships_and_financial_support/Scholarships_and_Bursaries_Browser",
            text : "Undergraduate"
        }
        ], 
        "bonusPoints" : [{
            link : "http://www.acu.edu.au/study_at_acu/alternate_entry/accessacu",
            text : "Summary"
        }        ], 
        "alternativeEntry" : [{
            link : "http://www.acu.edu.au/study_at_acu/alternate_entry",
        }], 
        "earlyEntry" : [{
            text: "ACU Guarantee",
            link: "https://www.acu.edu.au/study-at-acu/admission-pathways/acu-guarantee"
        }], 
        "atsi" : [{
            link : "http://www.acu.edu.au/about_acu/faculties,_institutes_and_centres/centres/centre_for_indigenous_education_and_research",
        }], 
        "exchange" : [{
            link : "http://www.acu.edu.au/courses/other_courses/exchange_and_study_abroad",
        }], 
        "accommodation" : [{
            link : "http://www.acu.edu.au/international/living_in_australia/accommodation",
        }], 
        "virtualTour" : [{
            link : "https://www.acu.edu.au/student-life/experience-uni-before-you-start/explore-your-local-campus/campus-tours",
        }], 
        events: [
            {
                campus:"Blacktown",
                date: new Date("25 July 2026"),
                url: "https://www.acu.edu.au/student-life/experience-uni-before-you-start/open-day"
            },
            {
                campus:"North Sydney",
                date: new Date("5 September 2026"),
                url: "https://www.acu.edu.au/student-life/experience-uni-before-you-start/open-day"
            },
            {
                campus:"Canberra",
                date: new Date("12 September 2026"),
                url: "https://www.acu.edu.au/student-life/experience-uni-before-you-start/open-day"
            },
            {
                campus:"Strathfield",
                date: new Date("16 August 2026"),
                url: "https://www.acu.edu.au/student-life/experience-uni-before-you-start/open-day"
            }
        ]
    },
    "Australian National University" : {
        id:"177",
        abbr: "ANU",
        states: ["ACT"],
        image:UniLogos["ANU"],
        "scholarships" : [{
            link : "http://students.anu.edu.au/scholarships/",
            text : "Summary"
        }], 
        "bonusPoints" : [{
            link : "http://www.anu.edu.au/study/apply/anu-adjustment-factors",
            text : "Summary"
        }], 
        "alternativeEntry" : [{
            link : "https://study.anu.edu.au/study-options/pathways-other-programs",
        }], 
        "earlyEntry" : [], 
        "atsi" : [{
            link : "http://indigenous.anu.edu.au/",
        }], 
        "exchange" : [{
            link : "https://www.anu.edu.au/students/careers-opportunities/global-programs",
        }],
        "accommodation" : [{
            link : "http://rcc.anu.edu.au/",
        }],
        "virtualTour" : [{
            link : "https://science.anu.edu.au/study/360-virtual-tours",
        }], 
        events: [
            { campus:"Canberra", date: new Date("20 March 2027"), url: "https://study.anu.edu.au/events/anu-open-day" }]
   },
    "Charles Sturt University" : {
        id:"181",
        abbr: "CSU",
        states: ["NSW"],
        image:UniLogos["CSU"],
        "scholarships" : [{
            link : "https://www.csu.edu.au/scholarships",
            text : "Summary"
        }], 
        "bonusPoints" : [{
            link : "https://study.csu.edu.au/apply/admission-pathways/atar-and-adjustment-factors",
            text : "Summary"
        }], 
        "alternativeEntry" : [{
            link : "https://study.csu.edu.au/apply/admission-pathways",
        }], 
        "earlyEntry" : [{
            text: "Advantage",
            link: "https://study.csu.edu.au/study-options/pathways/charles-sturt-advantage"
        }], 
        "atsi" : [{
            link : "https://www.csu.edu.au/current-students/support/first-nations-students/student-centres",
        }],
        "exchange" : [{
            link : "https://study.csu.edu.au/international/study-with-us/study-abroad-and-exchange",
        }],
        "accommodation" : [{
            link : "https://www.csu.edu.au/current-students/uni-life/accommodation",
        }], 
        "virtualTour" : [
            {link:"https://about.csu.edu.au/locations/campuses"}
        ], 
        events: [
            {
                campus:"Port Macquarie",
                date: new Date("2 August 2026"),
                url: "https://study.csu.edu.au/why-charles-sturt/events/open-day"
            },
            {
                campus:"Wagga Wagga",
                date: new Date("9 August 2026"),
                url: "https://study.csu.edu.au/why-charles-sturt/events/open-day"
            },
            {
                campus:"Albury-Wodonga",
                date: new Date("16 August 2026"),
                url: "https://study.csu.edu.au/why-charles-sturt/events/open-day"
            },
            {
                campus:"Bathurst",
                date: new Date("23 August 2026"),
                url: "https://study.csu.edu.au/why-charles-sturt/events/open-day"
            },
            {
                campus:"Orange",
                date: new Date("30 August 2026"),
                url: "https://study.csu.edu.au/why-charles-sturt/events/open-day"
            }
        ] 
    },    
    "CQ" : {
        id: "",
        abbr: "CQ",
        states: ["NSW", "SA", "QLD"],
        image: UniLogos["CQ"],
        "scholarships": [],
        "bonusPoints": [],
        "alternativeEntry": [],
        "earlyEntry": [],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [
            {
                text: "All Campuses",
                link:"https://www.cqu.edu.au/about-us/locations"
            },
            {
                text: "Brisbane",
                link:"https://www.youtube.com/watch?v=j46Abo2rGFg"
            }
        ],
        events: [
        ]
    },
    "Grifith University": {
        id: "",
        abbr: "Griffith",
        states: ["NSW", "QLD"],
        image: UniLogos["Griffith"],
        "scholarships": [],
        "bonusPoints": [],
        "alternativeEntry": [],
        "earlyEntry": [],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [
            {link:"https://www.youtube.com/watch?v=B8lXH_W8VOU"}
        ],
        events: [
            { campus:"Gold Coast", date: new Date("9 August 2026"), url: "https://www.griffith.edu.au/open-day" }
        ]
    },
    "Macquarie University" : {
        id:"187",
        abbr: "Macq",
        states: ["NSW"],
        image:UniLogos["Mq"],
        "scholarships" : [{
            link : "https://www.mq.edu.au/study/admissions-and-entry/scholarships",
            text : "Summary"
        },
        {
            link : "https://www.mq.edu.au/study/admissions-and-entry/scholarships/domestic",
            text : "Undergraduate"
        } 
        ], 
        "bonusPoints" : [{
            link : "https://www.mq.edu.au/study/admissions-and-entry/pathways/adjustment-factors",
            text : "Summary"
        }, 
        {
            link : "https://www.mq.edu.au/study/admissions/entry-requirements/domestic/macquarie-entry/adjustment-factors/academic-advantage/adjustment-factors-calculator",
            text : "Calculator"
        }
        ],
        "alternativeEntry" : [{
            link : "https://www.mq.edu.au/study/admissions-and-entry/pathways",
        }],
        "earlyEntry" : [{
            text: "Leaders and Achievers Early Entry",
            link: "https://www.mq.edu.au/study/high-school-students/getting-into-university/entry-schemes-and-pathways"
        }, {
            text: "SRS",
            link: "https://www.uac.edu.au/future-applicants/scholarships-and-schemes/schools-recommendation-schemes"
        }], 
        "atsi" : [{
            link : "https://students.mq.edu.au/uni-life/community/walanga-muru",
        }],
        "exchange" : [{
            link : "https://students.mq.edu.au/study/course/overseas",
        }], 
        "accommodation" : [{
            link : "http://www.mq.edu.au/about/campus-services-and-facilities/macquarie-university-accommodation",
        }], 
        "virtualTour" : [
            {link:"https://www.youtube.com/watch?v=0g0L1sTTfSU"}
        ], 
        events:[{ date: new Date("15 August 2026"), url: "https://event.mq.edu.au/open-day/" }]
    },    
    "National Art School": {
        id: "",
        abbr: "NAS",
        states: ["NSW"],
        image: UniLogos["NAS"],
        "scholarships": [],
        "bonusPoints": [],
        "alternativeEntry": [],
        "earlyEntry": [],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [
            {link:"https://artsandculture.google.com/partner/national-art-school"}
        ],
        events:[{  url: "https://nas.edu.au/events/nas-open-day-2026" }]
    },
    "University of Wollongong" : {
        id:"197",
        abbr: "UOW",
        states: ["NSW"],
        image:UniLogos["Wollongong"],
        "scholarships" : [{
            link : "http://www.uow.edu.au/about/scholarships/index.html",
            text : "Summary"
        }, {
            link : "https://scholarships.uow.edu.au/scholarships/search",
            text : "Undergraduate"
        }], 
        "bonusPoints" : [{
            link : "https://www.uow.edu.au/study/high-school/apply/",
            text : "Summary"
        }, 
        {
            link : "https://solss.uow.edu.au/owa/sid/hsc_bonus_points.display_bp_by_hsc_course",
            text : "Calculator"
        }
        ], 
        "alternativeEntry" : [{
            link : "https://www.uow.edu.au/study/admission-info/pathways/",
        }], 
        "earlyEntry" : [{
            link:"https://www.uow.edu.au/study/high-school/uow-early-admission/"
        }], 
        "atsi" : [{
            link : "http://www.uow.edu.au/wic/index.html",
        }], 
        "exchange" : [{
            link : "http://www.uow.edu.au/student/exchange/index.html",
        }], 
        "accommodation" : [{
            link : "http://www.uow.edu.au/about/accommodation/index.html",
        }], 
        "virtualTour" : [{
            link : "https://www.uow.edu.au/about/locations/campus-map/virtual-tours/",
        }], 
        events:[
            {
                campus: "Wollongong",
                date: new Date("27 June 2026"),
                url: "https://www.uow.edu.au/openday/"
            },
            {
                campus: "Liverpool",
                date: new Date("25 July 2026"),
                url: "https://www.uow.edu.au/openday/"
            }
        ] 
   },    
    "Southern Cross University" : {
        id:"188",
        abbr: "SCU",
        states: ["NSW", "QLD"],
        image:UniLogos["SouthernCross"],
        "scholarships" : [{
            link : "http://www.scu.edu.au/scholarships/",
            text : "Summary"
        }, {
            link : "https://www.scu.edu.au/scholarships/undergraduate-scholarships/",
            text : "Undergraduate"
        }], 
        "bonusPoints" : [], 
        "alternativeEntry" : [{
            link : "https://www.scu.edu.au/study/high-school-students/entry-pathways",
        }], 
        "earlyEntry" : [{
            text:"Star Early Offer",
            link:"https://www.scu.edu.au/star-early-offer/"
        }], 
        "atsi" : [{
            link : "https://www.scu.edu.au/current-students/services-and-support/indigenous-australian-student-services-iass/",
        }], 
        "exchange" : [{
            link : "https://www.scu.edu.au/current-students/global-experience/",
        }], 
        "accommodation" : [{
            link : "https://www.scu.edu.au/current-students/services-and-support/accommodation/",
        }], 
        "virtualTour" : [
            {
                text:"All Campuses",
                link:"https://www.scu.edu.au/experience/explore-our-campuses/"
            },
            {
                link : "https://www.scu.edu.au/study-at-scu/why-scu/locations/gold-coast/",
                text : "Gold Coast" 
            },
            {
                link : "https://www.scu.edu.au/study-at-scu/why-scu/locations/lismore/",
                text : "Lismore" 
            },
            {
                link : "https://www.scu.edu.au/study-at-scu/why-scu/locations/coffs-harbour/",
                text : "Coffs Harbour" 
            },
            {
                link : "https://www.youtube.com/watch?v=Ev3G4eLK4kA",
                text : "NMSC" 
            },
        ], 
        events:[
            {
                date: new Date("16 August 2026"),
                campus: "Northern Rivers",
                url: "https://www.scu.edu.au/open-day"
            },
            {
                date: new Date("9 August 2026"),
                campus: "Coffs Harbour",
                url: "https://www.scu.edu.au/open-day"
            },
            {
                date: new Date("23 August 2026"),
                campus: "Gold Coast",
                url: "https://www.scu.edu.au/open-day"
            },

        ]
   },    
    "University of Canberra" : {
        id:"189",
        abbr: "UC",
        states: ["ACT"],
        image:UniLogos["Canberra"],
        "scholarships" : [{
            link : "http://www.canberra.edu.au/scholarships",
            text : "Summary"
        },], 
        "bonusPoints" : [{
            link : "https://www.canberra.edu.au/future-students/get-into-uc/admissions-programs/year-12-adjustment-factors",
            text : "Summary"
        }], 
        "alternativeEntry" : [{
            link : "http://www.canberra.edu.au/future-students/applications/apply-now/alternative-entry",
        }], 
        "earlyEntry" : [{
            text:"SRS",
            link:"https://www.canberra.edu.au/future-students/apply-now/alternative-entry/schools-recommendation-scheme"
        }], 
        "atsi" : [{
            link : "https://www.canberra.edu.au/on-campus/health-and-support/medical-counselling/services-for-aboriginal-people-and-torres-strait-islanders",
        }], 
        "exchange" : [{
            link : "http://www.canberra.edu.au/study-abroad/travel-os",
        }], 
        "accommodation" : [{
            link : "http://www.canberra.edu.au/residences",
        }], 
        "virtualTour" : [{
            link : "https://www.canberra.edu.au/on-campus/campus-tours/virtual-tours",
        }], 
        events:[ { date: new Date("12 September 2026"), url: "https://www.canberra.edu.au/about-uc/events/open-day" }]
   },    
    "University of New England" : {
        id:"190",
        abbr: "UNE",
        states: ["NSW"],
        image:UniLogos["UNE"],
        "scholarships" : [{
            link : "http://www.une.edu.au/study/scholarships",
            text : "Summary"
        }, {
            link : "http://www.une.edu.au/scholarships/school-leaver",
            text : "Undergraduate"
        }], 
        "bonusPoints" : [{
            link : "https://www.une.edu.au/study/applying-to-une/entry-pathways/adjustment-factors",
            text : "Summary"
        }], 
        "alternativeEntry" : [{
            link : "https://www.une.edu.au/study/study-options/entry-pathways/entry-options",
        }],
        "earlyEntry" : [{
            link:"https://www.une.edu.au/study/study-on-campus/get-early-entry"
        }], 
        "atsi" : [{
            link : "http://www.une.edu.au/info-for/indigenous-matters",
        }], 
        "exchange" : [{
            link : "https://www.une.edu.au/international/study-options/learning-abroad",
        }],
        "accommodation" : [{
            link : "http://www.une.edu.au/campus-life/une-accommodation",
        }], 
        "virtualTour" : [{
            link : "https://www.une.edu.au/campus-life",
        }], 
        events:[
            {
                date: new Date("1 May 2026"),
                url: "https://www.une.edu.au/openday"
            },
        ]
   },    
    "UNSW" : {
        id:"4832",
        abbr: "UNSW",
        states: ["NSW"],
        image:UniLogos["UNSW"],
        "scholarships" : [{
            link : "https://www.unsw.edu.au/study/how-to-apply/scholarships",
            text : "Summary"
        }, {
            link : "http://www.scholarships.unsw.edu.au/scholarships/search?for=HIGH_SCHOOL_LEAVERS&show=all",
            text : "Undergraduate"
        }], 
        "bonusPoints" : [{
            link : "http://www.unsw.edu.au/domestic-undergraduate/hsc-plus",
            text : "Summary"
        }, 
        {
            link : "https://hscplus.unsw.edu.au",
            text : "Calculator"
        }
        ], 
        "alternativeEntry" : [{
            link : "https://www.unsw.edu.au/study/how-to-apply/undergraduate/admission-pathways",
            text : "Click Here"
        }], 
        "earlyEntry" : [{
            text:"Gateway Program",
            link:"https://www.futurestudents.unsw.edu.au/year-12"
        }], 
        "atsi" : [{
            link : "http://www.nuragili.unsw.edu.au/",
        }], 
        "exchange" : [{
            link : "https://www.unsw.edu.au/student/opportunities/overseas-study",
        }], 
        "accommodation" : [{
            link : "http://rc.unsw.edu.au/",
        }], 
        "virtualTour" : [
            {
                link : "http://360tour.unsw.edu.au/",
            }
        ], 
         events:[
            {
                date: new Date("5 September 2026"),
                url: "https://www.unsw.edu.au/openday"
            }
        ]
    },    
    "UNSW (ADFA)": {
        id: "",
        abbr: "ADFA",
        states: ["NSW", "VIC"],
        image: UniLogos["ADFA"],
        "scholarships": [],
        "bonusPoints": [],
        "alternativeEntry": [],
        "earlyEntry": [],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [
            {link:"https://www.youtube.com/watch?v=IWI74RY9IlA"}
        ],
        events:[
            {
                url: "https://www.unsw.edu.au/canberra/open-day"
            }
        ]
    },
    "University of Newcastle" : {
        id:"193",
        abbr: "UON",
        states: ["NSW"],
        image:UniLogos["Newcastle"],
        "scholarships" : [{
            link : "http://www.newcastle.edu.au/future-students/undergraduate-study/costs-and-scholarships",
            text : "Summary"
        }, {
            link : "https://www.newcastle.edu.au/scholarships#filter=level_undergraduate_first",
            text : "Undergraduate"
        }], 
        "bonusPoints" : [{
            link : "https://www.newcastle.edu.au/study/undergraduate/selection-ranks-and-entry-schemes",
            text : "Summary"
        }, 
        
        ], 
        "alternativeEntry" : [{
            link : "http://www.newcastle.edu.au/study/undergraduate/getting-in/other-pathways-and-study-options",
        }], 
        "earlyEntry" : [{
            text:"SRS",
            link:"https://www.newcastle.edu.au/study/undergraduate/getting-in/entry-schemes"
        }], 
        "atsi" : [{
            link : "https://www.newcastle.edu.au/study/pathways/yapug",
        }], 
        "exchange" : [{
            link : "http://www.newcastle.edu.au/international/study-with-us/study-abroad-and-exchange/study-overseas",
        }], 
        "accommodation" : [{
            link : "http://www.newcastle.edu.au/current-students/campus-environment/campus-life/accommodation",
        }], 
        "virtualTour" : [ 
            {link:"https://www.youtube.com/watch?v=u_O7gVbqV6w"}
        ], 
        events:[
            {
                campus: "Central Coast",
                date: new Date("29 August 2026"),
                url: "https://www.newcastle.edu.au/open-day"
            },
            {
                campus: "Newcastle",
                date: new Date("15 August 2026"),
                url: "https://www.newcastle.edu.au/open-day"
            }
        ] 
   },    
    "University of Sydney" : {
        id:"194",
        abbr: "USYD",
        states: ["NSW"],
        image:UniLogos["USYD"],
        "scholarships" : [{
            link : "http://sydney.edu.au/scholarships/",
            text : "Summary"
        }, {
            link : "https://www.sydney.edu.au/scholarships/domestic/bachelors-honours.html",
            text : "Undergraduate"
        }], 
        "bonusPoints" : [{
            link : "https://www.sydney.edu.au/study/applying/admission-pathways/future-leaders-scheme.html",
            text : "Summary"
        } 
        ], 
        "alternativeEntry" : [{
            link : "https://www.sydney.edu.au/study/applying/admission-pathways.html",
        }], 
        "earlyEntry" : [], 
        "atsi" : [{
            link : "http://sydney.edu.au/study/academic-support/aboriginal-and-torres-strait-islander-support.html",
        }], 
        "exchange" : [{
            link : "https://www.sydney.edu.au/study/student-life/student-exchange.html",
        }], 
        "accommodation" : [{
            link : "http://sydney.edu.au/current_students/accommodation/",
        }], 
        "virtualTour" : [{
            link : "https://www.sydney.edu.au/engage/visit/campus-tours.html",
        }],
        events:[
            {
                date: new Date("29 August 2026"),
                url: "https://openday.sydney.edu.au/"
            },
        ]
    },    
    "University of Technology Sydney" : {
        id:"195",
        abbr: "UTS",
        states: ["NSW"],
        image:UniLogos["UTS"],
        "scholarships" : [{
            link : "https://www.uts.edu.au/current-students/opportunities/scholarships-prizes-and-awards/scholarships-uts?utm_source=jobjump&utm_medium=sponsorship&utm_campaign=august-update",
            text : "Summary"
        }, {
            link : "https://www.uts.edu.au/study/scholarships?utm_source=jobjump&utm_medium=sponsorship&utm_campaign=august-update",
            text : "Undergraduate"
        }], 
        "bonusPoints" : [{
            link : "https://www.uts.edu.au/study/undergraduate/admission-requirements/admissions-schemes?utm_source=jobjump&utm_medium=sponsorship&utm_campaign=august-update ",
            text : "Summary"
        }, 
        {
            link : "https://www.uts.edu.au/study/undergraduate/high-school-students/year-12-bonus-scheme?utm_source=jobjump&utm_medium=sponsorship&utm_campaign=august-update",
            text : "Calculator"
        }
        ], 
        "alternativeEntry" : [{
            link : "https://www.uts.edu.au/study/undergraduate/non-current-school-leavers/entry-pathways?utm_source=jobjump&utm_medium=sponsorship&utm_campaign=august-update",
        }], 
        "earlyEntry" : [{
            text:"SRS",
            link:"https://www.uts.edu.au/study/undergraduate/essential-information/educational-access-schemes/schools?utm_source=jobjump&utm_medium=sponsorship&utm_campaign=august-update"
        }, {
            link:"https://www.uts.edu.au/future-students/undergraduate/admission-requirements/admissions-schemes/uts-early-entry-program?utm_source=jobjump&utm_medium=other&utm_campaign=august-update"
        }], 
        "atsi" : [{
            link : "https://www.uts.edu.au/study/indigenous-australians?utm_source=jobjump&utm_medium=sponsorship&utm_campaign=august-update",
        }], 
        "exchange" : [{
            link : "https://www.uts.edu.au/current-students/opportunities/global-exchange/what-global-exchange?utm_source=jobjump&utm_medium=sponsorship&utm_campaign=august-update",
        }], 
        "accommodation" : [{
            link : "https://www.uts.edu.au/current-students/support/uts-housing-service?utm_source=jobjump&utm_medium=sponsorship&utm_campaign=august-update",
        }], 
        "virtualTour" : [{
            link : "https://www.uts.edu.au/study/undergraduate/why-uts/experience-uts-vr?utm_source=jobjump&utm_medium=sponsorship&utm_campaign=august-update",
        }], 
        events:[
            {
                date: new Date("29 August 2026"),
                url: "https://www.uts.edu.au/events/open-day"
            }
        ] 
   },    
    "Notre Dame" : {
        id:"261",
        abbr: "ND",
        states: ["NSW", "WA"],
        image:UniLogos["NotreDame"],
        "scholarships" : [{
            link : "https://www.notredame.edu.au/current-students/opportunities/scholarships",
            text : "Summary"
        }], 
        "bonusPoints" : [],
        "alternativeEntry" : [],
        "earlyEntry" : [],
        "atsi" : [{
            link : "https://www.notredame.edu.au/study/aboriginal-torres-strait-islander-students",
        }],
        "exchange" : [{
            link : "https://www.notredame.edu.au/students/opportunities-and-experiences/study-abroad-and-exchange-programs",
        }],
        "accommodation" : [{
            link : "https://www.notredame.edu.au/students/student-life/accommodation",
        }],
        "virtualTour" : [{
            text: "Sydney",
            link: "https://www.youtube.com/watch?v=N_ZEGgD0cRI"
        },
        {
            text: "Fremantle & Perth",
            link: "https://www.youtube.com/playlist?list=PL6oOZd1z-ymwIrL0kpArHRGXFC8PYJrOj"
        },
        {
            text: "Broome",
            link: "https://www.youtube.com/watch?v=CWOb4eD-fKg&list=PL6oOZd1z-ymwIrL0kpArHRGXFC8PYJrOj&index=7"
        }],
        events:[
            {
                date: new Date("29 August 2026"),
                url: "https://www.notredame.edu.au/engage/visit-us/openday"
            },
        ] 
   },    
    "Western Sydney University" : {
        id:"196",
        abbr: "WSU",
        states: ["NSW"],
        image:UniLogos["WSU"],
        "scholarships" : [{
            link : "https://www.westernsydney.edu.au/scholarships",
            text : "Summary"
        }, {
            link : "https://www.westernsydney.edu.au/opportunities/scholarships/important-dates",
            text : "Undergraduate"
        }], 
        "bonusPoints" : [{
            link : "https://www.westernsydney.edu.au/future/study/how-to-apply/bonus-points/subject-bonus-points.html",
            text : "Summary & Calculator"
        }], 
        "alternativeEntry" : [{
            link : "https://www.westernsydney.edu.au/future/future_students_home/pathways-to-uws",
        }], 
        "earlyEntry" : [{
            text:"True Reward",
            link: "https://www.westernsydney.edu.au/future/study/application-pathways/hsc-true-reward.html" 
        }], 
        "atsi" : [{
            link : "https://www.westernsydney.edu.au/badanami/badanami_centre_for_indigenous_education/future_students",
        }], 
        "exchange" : [{
            link: "https://www.westernsydney.edu.au/globalmobility/goglobal",
            text: ""
        }], 
        "accommodation" : [{
            link : "https://www.westernsydney.edu.au/accommodation",
        }],
        "virtualTour" : [{
            link : "https://www.youtube.com/playlist?list=PL08mMPK6iVGYg_41H8nZNaiRZA4d8tWAl",
        }], 
        events:[
            {
                date: new Date("5 July 2026"),
                url: "https://www.westernsydney.edu.au/openday"
            }
        ]
   },    
   /*"Melbourne Inst Tech" : {
        id:"243",
        states: ["NSW", "VIC"],
        image:UniLogos["MIT"],
        "scholarships" : [{
            link : "http://www.mit.edu.au/study-with-us/scholarships",
            text : "Summary"
        }], 
        "bonusPoints" : [], 
        "alternativeEntry" : [], 
        "earlyEntry" : [], 
        "atsi" : [], 
        "exchange" : [], 
        "accommodation" : [], 
        "virtualTour" : [], 
 
   },*/
   "Deakin" : {
        id:"4755",
        abbr: "Deakikn",
        states: ["VIC"],
        image:UniLogos["Deakin"],
        "scholarships" : [{
            link : "https://www.deakin.edu.au/study/fees-and-scholarships/scholarships",
        }],
        "bonusPoints" : [{
            link : "https://www.deakin.edu.au/study/how-to-apply/equity-schemes-and-scholarships",
            text : "Summary"
        },
        {
            link : "https://www.deakin.edu.au/study/how-to-apply/equity-schemes-and-scholarships/equity-schemes-calculator",
            text : "Calculator"
        }],
        "alternativeEntry" : [{
            link: "https://www.deakin.edu.au/study/entry-pathways"
        }],
        "earlyEntry" : [],
        "atsi" : [{
            link:"https://www.deakin.edu.au/indigenous-students"
        }],
        "exchange" : [{
            link:"https://www.deakin.edu.au/students/study-support/study-abroad"
        }],
        "accommodation" : [{
            link: "https://www.deakin.edu.au/life-at-deakin/accommodation"
        }], 
        "virtualTour" : [{
            text: "Melbourne",
            link: "https://www.deakin.edu.au/locations/melbourne-burwood-campus"
        },
        {
            text: "Waurn Ponds (Geelong)",
            link: "https://www.deakin.edu.au/locations/geelong-waurn-ponds-campus"
        },
        {
            text: "Waterfront (Geelong)",
            link:"https://www.deakin.edu.au/locations/geelong-waterfront-campus"
        },
        {
            text: "Warrnambool",
            link: 'https://www.deakin.edu.au/locations/warrnambool-campus'
        },
        {
            text: "Online",
            link: "https://www.deakin.edu.au/study-online"
        }], 
        events: [
            {url:"https://openday.deakin.edu.au/"}
        ]
   },
   "Monash" : {
        id:"4757",
        abbr: "Monash",
        states: ["VIC"],
        image:UniLogos["Monash"],
        "scholarships" : [{
            link : "https://www.monash.edu/study/fees-scholarships/scholarships",
        }], 
        "bonusPoints" : [{
            link:"https://www.monash.edu/admissions/entry-requirements/atar/subject-adjustments",
        }],
        "alternativeEntry" : [{
            link: "https://www.monash.edu/study/courses/entry-pathways-domestic"
        }],
        "earlyEntry" : [{
            link: "https://www.monash.edu/study/how-to-apply/entry-schemes"
        }], 
        "atsi" : [{
            link: "https://www.monash.edu/indigenous-australians/study/admissions-and-pathways/miap-inap"
        }], 
        "exchange" : [{
            link: "https://www.monash.edu/study-abroad/outbound/exchange"
        }], 
        "accommodation" : [{
            link:"https://www.monash.edu/study/student-life/accommodation?id=1992104"
        }], 
        "virtualTour" : [{
            link: "https://www.monash.edu/discover/resources/self-guided-tours"
        }],
        events: [
            {url:"https://www.monash.edu/open-day"}
        ] 
   },
   "RMIT" : {
        id:"4736",
        abbr: "RMIT",
        states: ["VIC"],
        image:UniLogos["RMIT"],
        "scholarships" : [{
            link : "https://www.rmit.edu.au/scholarships",
        }],
        "bonusPoints" : [{
            link: "https://www.rmit.edu.au/study-with-us/applying-to-rmit/local-student-applications/access-rmit/atar-adjustment-factors"
        }],
        "alternativeEntry" : [{
            link:"https://www.rmit.edu.au/study-with-us/applying-to-rmit/local-student-applications/pathways"
        }], 
        "earlyEntry" : [{
            link:"https://www.rmit.edu.au/study-with-us/applying-to-rmit/local-student-applications/equity-access-schemes/types-of-equity-access"
        }], 
        "atsi" : [{
            link:"https://www.rmit.edu.au/students/support-and-facilities/student-support/aboriginal-and-torres-strait-islander-students"
        }], 
        "exchange" : [{
            link:"https://www.rmit.edu.au/students/work-study-opportunities/global-study-and-work"
        }], 
        "accommodation" : [{
            link:"https://www.rmit.edu.au/students/support-and-facilities/student-support/accommodation"
        }], 
        "virtualTour" : [{
            text: "Melbourne City",
            link: "https://www.rmit.edu.au/about/our-locations-and-facilities/locations/melbourne-city-campus"
        },
        {
            text:"Melbourne Bundoora",
            link:"https://www.rmit.edu.au/about/our-locations-and-facilities/locations/melbourne-bundoora-campus"
        },
        {
            text:"Melbourne Brunswick",
            link:"https://www.rmit.edu.au/about/our-locations-and-facilities/locations/melbourne-brunswick-campus"
        },
        {
            text: "Regional",
            link:"https://www.rmit.edu.au/about/our-locations-and-facilities/locations/regional-sites"
        }], 
        events: [
            {url:"https://www.rmit.edu.au/openday"}
        ]
   },

   "Swinburn" : {
        id:"4759",
        abbr: "Swinburn",
        states: ["VIC"],
        image:UniLogos["Swinburne"],
        "scholarships" : [{
            link : "https://www.swinburne.edu.au/study/options/scholarships/",
        }], 
        "bonusPoints" : [{
            link: "https://www.swinburne.edu.au/atar-calculator/"
        }],
        "alternativeEntry" : [{
            link:"https://www.swinburne.edu.au/study/degrees/pathways/"
        }], 
        "earlyEntry" : [], 
        "atsi" : [{
            link:"https://www.swinburne.edu.au/about/our-university/indigenous-matters/indigenous-student-support/"
        }], 
        "exchange" : [{
            link:"https://www.swinburne.edu.au/life-at-swinburne/study-abroad-exchange/"
        }], 
        "accommodation" : [{
            link:"https://www.swinburne.edu.au/current-students/student-services-support/accommodation/"
        }], 
        "virtualTour" : [{
            text: "360 Photos",
            link:"https://www.swinburne.edu.au/virtual-tour/360/photos/"
        },
        {
            text: "Campus Video Tours",
            link:"https://www.swinburne.edu.au/welcome/"
        }],
        events: [
            {url:"https://www.swinburne.edu.au/openday/"}
        ] 
   },

   "University of Melbourne" : {
        id:"4876",
        abbr: "UM",
        states: ["VIC"],
        image:UniLogos["Melbourne"],
        "scholarships" : [{
            link : "https://scholarships.unimelb.edu.au/",
        }], 
        "bonusPoints" : [{
            link: "https://study.unimelb.edu.au/how-to-apply/equity-entry-schemes/access-melbourne-undergraduate"
        }],
        "alternativeEntry" : [{
            link: "https://study.unimelb.edu.au/how-to-apply/special-entry-access-schemes"
        }], 
        "earlyEntry" : [{
            link: "https://study.unimelb.edu.au/how-to-apply/special-entry-access-schemes"
        }], 
        "atsi" : [{
            link: "https://study.unimelb.edu.au/study-with-us/programs-for-indigenous-students"
        }], 
        "exchange" : [{
            link: "https://students.unimelb.edu.au/course-admin/study-overseas"
        }],
        "accommodation" : [{
            link: "https://study.unimelb.edu.au/your-experience/accommodation"
        }],
        "virtualTour" : [{
            link: "https://d3c1xdykvg3r8z.cloudfront.net/"
        }],
        events: [
            {url:"https://study.unimelb.edu.au/opendays?in_c=study_openday"}
        ] 
   },

   "Victoria University" : {
        id:"4747",
        abbr: "VU",
        states: ["VIC"],
        image:UniLogos["Victoria"],
        "scholarships" : [{
            link : "https://www.vu.edu.au/study-at-vu/fees-scholarships/scholarships",
        }], 
        "bonusPoints" : [{
            link : "https://www.vu.edu.au/study-at-vu/apply-to-vu/atar-at-vu",
        }],
        "alternativeEntry" : [{
            link : "https://www.vu.edu.au/study-at-vu/how-to-apply/special-admission-programs/vu-guaranteed",
        }], 
        "earlyEntry" : [{
            link: "https://www.vu.edu.au/about-vu/news-events/news/early-entry-program-means-less-stress-more-success-for-regional-students"
        }], 
        "atsi" : [{
            link : "https://www.vu.edu.au/study-at-vu/information-for/aboriginal-torres-strait-islander-students",
        }],
        "exchange" : [{
            link : "https://www.vu.edu.au/current-students/careers-opportunities/study-overseas/exchange-programs",
        }], 
        "accommodation" : [{
            link : "https://www.vu.edu.au/current-students/campus-life/housing-accommodation",
        }], 
        "virtualTour" : [{
            link: "https://www.youtube.com/playlist?list=PL3y_wByS2sRPafspC45HiKnnLqzejFYqs"
        }], 
        events: [
            {url:"https://openday.vu.edu.au/"}
        ]
 
   },

   "Federation University" : {
        id:"4745",
        abbr: "Fed",
        states: ["VIC"],
        image:UniLogos["Federation"],
        "scholarships" : [{
            link : "https://federation.edu.au/current-students/assistance-support-and-services/scholarships",
        }], 
        "bonusPoints" : [], 
        "alternativeEntry" : [{
            link : "https://federation.edu.au/future-students/study-at-federation/which-course/pathways",
        }], 
        "earlyEntry" : [], 
        "atsi" : [{
            link : "https://federation.edu.au/about-us/our-university/indigenous-matters/aboriginal-education-centre/student-information",
        }], 
        "exchange" : [{
            link : "https://www.federation.edu.au/students/get-involved/study-overseas/",
        }],
        "accommodation" : [{
            link : "https://www.federation.edu.au/study/why-federation/accommodation/",
        }],
        "virtualTour" : [{
            link: "https://federation.edu.au/future-students/study-at-federation/virtual-tours?utm_source=redirect&utm_medium=web&utm_campaign=virtualtour"
        }], 
        events: [
            {url:"https://federation.edu.au/future-students/study-at-federation/open-day?utm_source=redirect&utm_medium=web&utm_campaign=openday"}
        ] 
   },
   "La Trobe University" : {
        id:"4765",
        abbr: "La Trobe",
        states: ["VIC", "NSW"],
        image:UniLogos["LaTrobe"],
        "scholarships" : [{
            link : "https://www.latrobe.edu.au/study/scholarships",
        }],
        "bonusPoints" : [{
            link : "https://www.latrobe.edu.au/study/undergrad/atar-adjustment-factors-calculator",
        }],
        "alternativeEntry" : [{
            link : "https://www.latrobe.edu.au/study/apply/pathways/undergrad",
        }],
        "earlyEntry" : [{
            link: "https://www.latrobe.edu.au/study/aspire"
        }], 
        "atsi" : [{
            link : "https://www.latrobe.edu.au/study/undergrad/resources/indigenous-students",
        }], 
        "exchange" : [{
            link : "https://www.latrobe.edu.au/courses/mba/study-tours-and-exchange",
        }], 
        "accommodation" : [{
            link : "https://www.latrobe.edu.au/accommodation",
        }], 
        "virtualTour" : [{
            link: "https://www.latrobe.edu.au/shepparton/about",
            text: "Shepparton"
        },
        {
            link:"https://www.latrobe.edu.au/melbourne/about",
            text:"Melbourne"
        },
        {
            link: "https://www.latrobe.edu.au/bendigo/about",
            text: "Bendigo"
        },
        {
            link: "https://www.latrobe.edu.au/albury-wodonga/about",
            text: "Albury Wodonga"
        },
        {
            link:"https://www.latrobe.edu.au/mildura/about",
            text:"Mildura"
        }
    ],
    events: [
        {
            campus: "Albury",
            date: new Date("16 August 2026"),
            url: "https://www.latrobe.edu.au/openday"
        }
    ]
   },
   "University of Western Australia": {
        "id": "5045",
        "abbr": "UWA",
        "states": [ "WA" ],
        "image": UniLogos["UWA"],
        "scholarships": [
            { "link": "https://www.uwa.edu.au/study/Scholarships/Explore", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [
            { "link": "https://www.uwa.edu.au/study/How-to-apply/Admission-entry-pathways/Experience-based-entry" }
        ],
        "earlyEntry": [
            { "link": "https://www.uwa.edu.au/study/How-to-apply/Early-Offers" }
        ],
        "atsi": [
            { "link": "https://www.uwa.edu.au/about/schools/sis" }
        ],
        "exchange": [
            { "link": "https://www.uwa.edu.au/study/discover-uwa/student-exchange/outbound" }
        ],
        "accommodation": [
            { "link": "https://www.uwa.edu.au/life-at-uwa/accommodation" }
        ],
        "virtualTour": [
            { "link": "https://www.uwa.edu.au/about/locations/campus-tours" }
        ],
        "events": []
    },
    "Charles Darwin University": {
        "id": "4860",
        "abbr": "CD",
        "states": [ "NT", "NSW" ],
        "image": UniLogos["CharlesDarwin"],
        "scholarships": [
            { "link": "https://www.cdu.edu.au/scholarships", "text": "Summary" }
        ],
        "bonusPoints": [
            { "link": "https://www.cdu.edu.au/study/essentials/study-pathways/school-leaver-admission-pathways" }
        ],
        "alternativeEntry": [
            { "link": "https://www.cdu.edu.au/study/essentials/study-pathways/pathways-study" }
        ],
        "earlyEntry": [
        ],
        "atsi": [
            { "link": "https://firstnationssuccess.cdu.edu.au/", "text": "First Nations Success" },
            { "link": "https://www.cdu.edu.au/study/essentials/study-pathways/first-nations-pathways", "text": "Pathways" },
            { "link": "https://www.cdu.online/first-nations-leadership", "text": "Leadership" }
        ],
        "exchange": [
            { "link": "https://www.cdu.edu.au/international/learning-abroad/outbound-out-australia" }
        ],
        "accommodation": [
            { "link": "https://www.cdu.edu.au/accommodation-services" }
        ],
        "virtualTour": [
            { "link": "https://www.youtube.com/watch?v=1Mqe3g4yiFQ&list=PLgAfLRKDtQ_pJ6YzViIp5PvPuhURnck2r" }
        ],
        "events": []
    },
    "University of Tasmania": {
        "id": "4859",
        "abbr": "UTAS",
        "states": [ "TAS", "NSW" ],
        "image": UniLogos["UTAS"],
        "scholarships": [
            { "link": "https://www.utas.edu.au/scholarships", "text": "Summary" }
        ],
        "bonusPoints": [
            
        ],
        "alternativeEntry": [
            { "link": "https://www.utas.edu.au/study/pathways-to-university" }
        ],
        "earlyEntry": [
            { "link": "https://www.utas.edu.au/study/schools-recommendation-program" }
        ],
        "atsi": [{"link": 'https://www.utas.edu.au/uni-life/aboriginal-students-riawunna'}],
        "exchange": [{"link": "https://www.utas.edu.au/study/learning-abroad"}],
        "accommodation": [{"link": "https://www.utas.edu.au/uni-life/accommodation"}],
        "virtualTour": [{"link": "https://www.utas.edu.au/about/campuses/tours"}],
        "events": []
    },
    "Australian Maritime College": {
        "id": "176",
        "abbr": "AMC",
        "states": [ "TAS" ],
        "image": UniLogos["AMC"],
        "scholarships": [
            { "link": "https://www.utas.edu.au/study/scholarships-fees-and-costs/domestic-scholarships/a-z?code=SCH_AMCS", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [],
        "earlyEntry": [],
        "atsi": [{"link":"https://www.utas.edu.au/uni-life/aboriginal-students-riawunna"}],
        "exchange": [],
        "accommodation": [{"link":"https://www.utas.edu.au/uni-life/accommodation/launceston"}],
        "virtualTour": [{"link":"https://tours.utas.edu.au/#amc"}],
        "events": []
    },
    "Murdoch University": {
        "id": "5046",
        "abbr": "MU",
        "states": [ "WA" ],
        "image": UniLogos["Murdoch"],
        "scholarships": [
            { "link": "https://www.murdoch.edu.au/study/scholarships", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [
            { "link": "https://www.murdoch.edu.au/study/pathways-to-uni" }
        ],
        "earlyEntry": [
            { "link": "https://www.murdoch.edu.au/study/how-to-apply/year-12-early-offer-program" }
        ],
        "atsi": [
            { "link": "https://www.murdoch.edu.au/explore/support-services/kulbardi-aboriginal-centre" }
        ],
        "exchange": [
            { "link": "https://www.murdoch.edu.au/mymurdoch/support-advice/travel-while-you-learn" }
        ],
        "accommodation": [
            { "link": "https://www.murdoch.edu.au/study/international-students/life-in-perth/accommodation" }
        ],
        "virtualTour": [
            { "link": "https://www.murdoch.edu.au/explore/about-murdoch/our-locations/perth-campus", "text": "Perth" }
        ],
        "events": []
    },
    "Adelaide University": {
        "id": "5031",
        "abbr": "AdelaideUni",
        "states": [ "SA" ],
        "image": UniLogos["Adelaide"],
        "scholarships": [
            { "link": "https://adelaide.edu.au/study/scholarships/", "text": "Summary" }
        ],
        "bonusPoints": [
            { "link": "https://ask.adelaideuni.edu.au/app/answers/detail/a_id/4226/~/what-are-adjustment-factors-and-how-are-they-applied", "text": "Summary" }
        ],
        "alternativeEntry": [
            { "link": "https://adelaide.edu.au/study/how-to-apply/entry-pathways/" }
        ],
        "earlyEntry": [
            { "link": "https://adelaide.edu.au/study/how-to-apply/entry-pathways/activate/" }
        ],
        "atsi": [
            { "link": "https://adelaide.edu.au/about/first-nations/" }
        ],
        "exchange": [
            { "link": "https://adelaide.edu.au/study/global-learning/" }
        ],
        "accommodation": [
            { "link": "https://adelaide.edu.au/life-at-adelaide/accommodation/student-accommodation/" }
        ],
        "virtualTour": [ ],
        "events": []
    },
    "University of Queensland": {
        "id": "4725",
        "abbr": "UQ",
        "states": [ "QLD" ],
        "image": UniLogos["UQLD"],
        "scholarships": [
            { "link": "https://scholarships.uq.edu.au", "text": "Summary" }
        ],
        "bonusPoints": [
            { "link": "https://future-students.uq.edu.au/admissions/undergraduate/review-admission-schemes/subject-incentive-scheme", "text": "Summary" }
        ],
        "alternativeEntry": [
            { "link": "https://future-students.uq.edu.au/admissions/undergraduate/consider-your-pathway-options" }
        ],
        "earlyEntry": [
            { "link": "https://study.uq.edu.au/admissions/undergraduate/review-entry-requirements/guaranteed-atar" }
        ],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [],
        "events": []
    },
    "Queensland University of Technology": {
        "id": "4726",
        "abbr": "QUT",
        "states": [ "QLD" ],
        "image": UniLogos["QUT"],
        "scholarships": [
            { "link": "https://www.qut.edu.au/study/fees-and-scholarships/scholarships", "text": "Summary" }
        ],
        "bonusPoints": [
            { "link": "https://www.qut.edu.au/study/applying/adjustment-schemes", "text": "Summary" }
        ],
        "alternativeEntry": [
            { "link": "https://www.qut.edu.au/study/applying/adjustment-schemes" }
        ],
        "earlyEntry": [
            { "link": "https://www.qut.edu.au/study/applying/year-12-early-offer-scheme" }
        ],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [
            { "link": "https://www.youtube.com/watch?v=ES-PV20x3Bs" }
        ],
        "events": []
    },
    "Flinders University": {
        "id": "5033",
        "abbr": "Flinders",
        "states": [ "SA" ],
        "image": UniLogos["Flinders"],
        "scholarships": [
            { "link": "https://students.flinders.edu.au/finances-and-admin/support/scholarships", "text": "Summary" }
        ],
        "bonusPoints": [
            { "link": "https://www.flinders.edu.au/study/pathways/year-12-entry/universities-equity-scheme", "text": "Summary" }
        ],
        "alternativeEntry": [
            { "link": "https://www.flinders.edu.au/study/pathways" }
        ],
        "earlyEntry": [
            { "link": "https://www.flinders.edu.au/study/pathways/year-12-entry" }
        ],
        "atsi": [
            { "link": "https://www.flinders.edu.au/study/indigenous-students" }
        ],
        "exchange": [
            { "link": "https://students.flinders.edu.au/my-course/enrolment/study-abroad-exchange" }
        ],
        "accommodation": [
            { "link": "https://www.flinders.edu.au/international/living-in-adelaide/accommodation" }
        ],
        "virtualTour": [
            { "link": "https://www.flinders.edu.au/study" }
        ],
        "events": []
    },
    "Edith Cowan University": {
        "id": "5042",
        "abbr": "EC",
        "states": [ "WA" ],
        "image": UniLogos["Edith"],
        "scholarships": [
            { "link": "https://www.ecu.edu.au/scholarships/overview", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [
            { "link": "https://www.ecu.edu.au/future-students/course-entry/experience-based-entry-scheme" }
        ],
        "earlyEntry": [],
        "atsi": [
            { "link": "https://www.ecu.edu.au/centres/kurongkurl-katitjin/overview" }
        ],
        "exchange": [
            { "link": "https://www.ecu.edu.au/centres/international-office/our-services/outbound-learning-abroad/student-exchange" }
        ],
        "accommodation": [
            { "link": "https://www.ecu.edu.au/about-ecu/campus-facilities/accommodation" }
        ],
        "virtualTour": [ ],
        "events": []
    },
    "Curtin University": {
        "id": "5043",
        "abbr": "Curtin",
        "states": [ "WA" ],
        "image": UniLogos["Curtin"],
        "scholarships": [
            { "link": "https://scholarships.curtin.edu.au", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [
            { "link": "https://study.curtin.edu.au/applying/pathways" }
        ],
        "earlyEntry": [
            { "link": "https://www.curtin.edu.au/study/undergraduate/early-offers/" }
        ],
        "atsi": [],
        "exchange": [
            { "link": "https://www.curtin.edu.au/study/learning-experience/global-study/" }
        ],
        "accommodation": [
            { "link": "https://www.curtin.edu.au/study/campus-life/accommodation/" }
        ],
        "virtualTour": [
            { "link": "https://www.curtin.edu.au/study/campus-life/explore-perth/", "text": "Perth" },
            { "link": "https://www.curtin.edu.au/study/campus-life/regional-study/", "text": "Regional" }
        ],
        "events": []
    },
    "University of Southern Queensland": {
        "id": "4723",
        "abbr": "USQ",
        "states": [ "QLD" ],
        "image": UniLogos["USQ"],
        "scholarships": [
            { "link": "https://www.usq.edu.au/scholarships", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [
            { "link": "https://www.usq.edu.au/study/degrees/pathway-programs" }
        ],
        "earlyEntry": [],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [
            { "link": "https://www.unisq.edu.au/about-unisq/locations" }
        ],
        "events": []
    },
    "Torrens University Australia": {
        "id": "4814",
        "abbr": "Torrens",
        "states": [ "SA", "QLD", "NSW" ],
        "image": UniLogos["Torrens"],
        "scholarships": [
            { "link": "https://www.torrens.edu.au/apply-online/scholarships", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [],
        "earlyEntry": [
            { "link": "https://www.torrens.edu.au/apply-online/early-entry-program" }
        ],
        "atsi": [
            { "link": "https://studenthub.torrens.edu.au/Hub/First-Nations-Students" }
        ],
        "exchange": [
            { "link": "https://studenthub.torrens.edu.au/Hub/Study/Study-Abroad" }
        ],
        "accommodation": [
            { "link": "https://www.torrens.edu.au/studying-with-us/international-students/living-in-australia/student-accommodation" }
        ],
        "virtualTour": [
            { "link": "https://www.torrens.edu.au/campuses" }
        ],
        "events": [
            {
                "campus": "Sydney",
                "date": new Date("29 August 2026"),
                "url": "https://www.torrens.edu.au/whats-on/open-day/sydney"
            }
        ]
    },
    "James Cook University": {
        "id": "4714",
        "abbr": "JC",
        "states": [ "QLD" ],
        "image": UniLogos["JamesCook"],
        "scholarships": [
            { "link": "https://www.jcu.edu.au/scholarships-@-jcu", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [
            { "link": "https://www.jcu.edu.au/pathways-to-university" }
        ],
        "earlyEntry": [],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [],
        "events": []
    },
    "Bond University": {
        "id": "4718",
        "abbr": "Bond",
        "states": [ "QLD" ],
        "image": UniLogos["Bond"],
        "scholarships": [
            { "link": "https://bond.edu.au/future-students/study-bond/how-apply/scholarships", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [
            { "link": "https://bond.edu.au/future-students/study-bond/how-apply/application-process/english-pathways-and-diploma-application" }
        ],
        "earlyEntry": [],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [],
        "events": []
    },
    "University of the Sunshine Coast": {
        "id": "4727",
        "abbr": "USC",
        "states": [
            "QLD"
        ],
        "image": UniLogos["SunshinCoast"],
        "scholarships": [
            { "link": "https://www.usc.edu.au/study/scholarships", "text": "Summary" }
        ],
        "bonusPoints": [
            { "link": "https://www.usc.edu.au/study/how-do-i-apply/pathways-to-study/access-usc", "text": "Summary" }
        ],
        "alternativeEntry": [
            { "link": "https://www.usc.edu.au/study/how-do-i-apply/pathways-to-study/non-year-12-entry" }
        ],
        "earlyEntry": [],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [],
        "events": []
    },
    "Engineering Institute of Technology": {
        "id": "5048",
        "abbr": "EIT",
        "states": [ "WA" ],
        "image": UniLogos["EIT"],
        "scholarships": [
            { "link": "https://www.eit.edu.au/how-to-apply/scholarships/", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [],
        "earlyEntry": [],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [],
        "events": []
    },
    "Christian Heritage College": {
        "id": "4722",
        "abbr": "CHC",
        "states": [ "QLD" ],
        "image": UniLogos["CHC"],
        "scholarships": [
            { "link": "https://chc.edu.au/scholarships", "text": "Summary" }
        ],
        "bonusPoints": [],
        "alternativeEntry": [
            { "link": "https://chc.edu.au/credit-transfer" }
        ],
        "earlyEntry": [],
        "atsi": [],
        "exchange": [],
        "accommodation": [],
        "virtualTour": [],
        "events": []
    }
}

export {uniConfig, uniCategoryPrettyNames, uniCategoryImages};